var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('h1',[_vm._v(_vm._s(_vm.user.attributes.given_name)+" "+_vm._s(_vm.user.attributes.family_name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }